module.exports = __webpack_public_path__ + "img/logo_rsv.bb058837.png";